import { Injectable } from '@angular/core';
import {
  CityParkingUserLineDto,
  CityParkingUserLineResponse,
  LineOADashboardSummaryDto,
  LineOARecentActivityDto,
} from '../../models/lineOA.model';

@Injectable({
  providedIn: 'root',
})
export class MapperLineOaService {
  mapUserLineFromDto(dto: CityParkingUserLineDto): CityParkingUserLineResponse {
    return {
      id: dto.id,
      cpUserId: dto.id,
      name: dto.name ?? '',
      fullName: dto.fullName ?? '',
      uid: dto.uid ?? '',
      phone: dto.phone ?? '',
      pictureUrl: dto.pictureUrl ?? '',
      userStautsId: dto.userStautsId ?? 0,
      language: dto.language ?? '',
      createDate: dto.createDate ? new Date(dto.createDate) : null,
    };
  }

  mapSearchField(searchType: 'name' | 'lineName' | 'phone'): string {
    switch (searchType) {
      case 'lineName':
        return 'line_name';
      case 'phone':
        return 'phone';
      default:
        return 'name';
    }
  }

  mapSortColumn(sortColumn: string): string {
    switch (sortColumn) {
      case 'fullName':
        return 'line_name';
      case 'registerDate':
        return 'createdate';
      default:
        return sortColumn || 'id';
    }
  }

  mapDashboardStats(
    summary: LineOADashboardSummaryDto,
    recentActivity: LineOARecentActivityDto[] = [],
    chartMembers: CityParkingUserLineDto[] = [],
  ) {
    return {
      dashboardStats: [
        { title: 'สมาชิกทั้งหมด', subtitle: '', value: summary.total.toLocaleString(), icon: 'group', color: 'text-blue-600' },
        { title: 'สมาชิกใหม่ (7 วัน)', subtitle: 'ล่าสุด', value: summary.newThisWeek.toLocaleString(), icon: 'person_add', color: 'text-amber-500' },
        { title: 'ผู้ใช้ภาษาไทย', subtitle: '', value: summary.thCount.toLocaleString(), icon: 'translate', color: 'text-purple-600' },
        { title: 'ผู้ใช้ภาษาอังกฤษ', subtitle: '', value: summary.enCount.toLocaleString(), icon: 'language', color: 'text-pink-500' },
      ],
      newPercent: summary.newPercent,
      oldPercent: summary.oldPercent,
      recentActivity: recentActivity.map(item => ({
        initial: item.fullName ? item.fullName.charAt(0).toUpperCase() : '?',
        name: item.fullName,
        timeAgo: '',
        info: 'ลงทะเบียนสมาชิกใหม่',
        color: '',
        createDate: item.createDate,
        id: item.id,
      })),
      chartMembers: chartMembers.map(dto => this.mapUserLineFromDto(dto)),
    };
  }
}
